import React from "react";
import styles from "./searchField.module.scss";

export const SearchField = ({
    onClick = () => {
        //do nothing
    },
    onChange = () => {
        //do nothing
    },
    placeholder = "Pesquisa aqui",
    checkDisabled = false,
    search = ""
}) => {
    return (
        <div className="containerSearch conteudo-tabela d-flex justify-content-center">
          <input
            id="busca"
            type="text"
            placeholder={placeholder}
            name="busca"
            className="input-pesquisar"
            value={search}
            onChange={onChange}
        />
        <div className="containerIconSearch" />
          <span>
              <button
                  className={checkDisabled ? styles.buttonSearchBlock : styles.buttonSearch}
                  type="submit"
                    onClick={onClick}
                    disabled={checkDisabled}
              >
                  Pesquisar
              </button>
          </span>
        </div>
    );
};
